import { Injectable } from '@angular/core';
import { PaginatorFilters } from '@michelin/theme';

@Injectable({
  providedIn: 'root'
})
export class PaginatorService {
  /**
   * Get query params
   *
   * @param paginatorFilters the paginator filters
   */
  getQueryParams(paginatorFilters: PaginatorFilters): string {
    let queryParams = '';

    // If there is not paginator filters, just return empty string
    if (paginatorFilters) {
      queryParams = this.handlePaginator(paginatorFilters);
    }
    return queryParams;
  }

  /**
   * The private method that handles the paginator if it exists
   *
   * @param paginatorFilters the paginator to handle
   * @return the string corresponding to the paginator;
   */
  private handlePaginator(paginatorFilters: PaginatorFilters): string {
    let queryParams = '';

    if (paginatorFilters.page) {
      queryParams += `&page=${paginatorFilters.page - 1}`;
    }
    if (paginatorFilters.limit) {
      queryParams += `&size=${paginatorFilters.limit}`;
    }
    if (paginatorFilters.sort) {
      queryParams += `&sort=${paginatorFilters.sort.replace(':', ',')}`;
    }
    if (paginatorFilters.extraFilters) {
      Object.entries(paginatorFilters.extraFilters).forEach(([key, value]) => {
        if (key !== 'date' && value !== undefined && value !== null) {
          queryParams += `&${key}=${value}`;
        }
      });
    }
    if (queryParams.length) {
      queryParams = `?${queryParams.substring(1)}`;
    }
    return queryParams;
  }
}
